module.exports = __webpack_public_path__ + "img/main-bg.c3cc8577.jpg";